import styled from 'styled-components';
import theme from '../../theme'; // Assuming theme is in src/theme.js

export const ProfileContainer = styled.div`
  padding-top: 20px;
  padding-left: 10px;
  padding-right: 10px;
  padding-bottom: ${({ isPublicProfile }) => (isPublicProfile ? '20px' : '100px')};
  width: 100%;
  margin: 0 auto;
  background-color: ${theme.colors.background};
  min-height: 100vh; /* Use min-height to ensure it fills screen */
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  box-sizing: border-box;
  overflow-y: auto;

  @media (min-width: 801px) {
    padding-left: 280px; /* Width of the SideMenu */
    padding-bottom: 20px; /* Reset bottom padding for desktop */
    align-items: center; /* Center content horizontally within the remaining space */
  }

  /* Hide scrollbar for Chrome, Safari and Opera */
  &::-webkit-scrollbar {
    display: none;
  }

  /* Hide scrollbar for IE, Edge and Firefox */
  -ms-overflow-style: none;  /* IE and Edge */
  scrollbar-width: none;  /* Firefox */
`;

export const BackButton = styled.img`
  position: absolute;
  top: 25px; /* Adjust as needed */
  left: 20px; /* Adjust as needed */
  width: 30px; /* Increased size */
  height: 30px; /* Increased size */
  cursor: pointer;
  z-index: 2; /* Lower z-index since container's is removed */
`;

export const ProfileHeader = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 20px; /* Reduced from 30px */
  margin-bottom: 10px; /* Reduced from 20px */
  width: 100%;
`;

export const ProfilePicture = styled.div`
  width: 90px; /* Reduced from 110px */
  height: 90px; /* Reduced from 110px */
  flex-shrink: 0;
  aspect-ratio: 1 / 1;
  border-radius: 100px; /* Use 50% for perfect circle with aspect-ratio */
  border: 1px solid #E5E5E5;
  background: url(${props => props.src || '/assets/images/default-avatar.png'}) lightgray 50% / cover no-repeat;
  margin-bottom: 15px;
`;

export const Username = styled.h2`
  color: #4C4C4C;
  font-family: ${theme.fonts.main};
  font-size: 20px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  margin: 0;
`;

export const StatsContainer = styled.div`
  display: flex;
  justify-content: space-around; /* Distribute items evenly */
  align-items: center;
  width: 95%; /* Updated percentage */
  max-width: 500px; /* Added max-width */
  margin: 15px auto; /* Center the container, Reduced top/bottom margin from 20px */
  padding-bottom: 15px;
  /* border-bottom: 1px solid #eee; // Removed per layout */
`;

export const DomainIcon = styled.div`
  width: 20px;
  height: 20px;
  flex-shrink: 0;
  aspect-ratio: 1/1;
  background: url(${props => props.src}) lightgray 50% / cover no-repeat;
  border-radius: 50%; // Make it circular for consistency
`;

export const DomainCounter = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 31px;
  height: 19px;
  flex-shrink: 0;
  border-radius: 5px;
  border: 1px solid #E6E6E6;
  background: rgba(255, 255, 255, 0.00);
  color: #8D8D8D;
  font-family: ${theme.fonts.main}; // Use theme font
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  margin-left: 8px; // Space between icon and counter
`;

export const StatItem = styled.div`
  text-align: center; /* Default alignment */
  display: flex;
  flex-direction: column; /* Default direction */
  align-items: center; /* Default alignment */
  cursor: ${props => props.clickable ? 'pointer' : 'default'};
  min-width: 80px;
`;

export const StatValue = styled.div`
  color: #4C4C4C;
  font-family: ${theme.fonts.main};
  font-size: 20px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
`;

export const StatLabel = styled.div`
  color: #8D8D8D;
  font-family: ${theme.fonts.main};
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  margin-top: 4px;
  display: ${props => props.hidden ? 'none' : 'block'};
`;

export const RecapStatLabel = styled.div`
  color: #FFF;
  font-family: 'Gabarito', sans-serif;
  font-size: 14px; /* Adjusted size */
  font-weight: 400;
  line-height: normal;
  margin-left: 10%;
  margin-top: 0;
`;

export const VerticalSeparator = styled.div`
  width: 2px;
  height: 48.01px; /* Figma spec */
  background: #E6E6E6;
`;

export const ButtonContainer = styled.div`
  display: flex;
  /* justify-content: center; // Let flex items determine spacing */
  gap: 15px; /* Space between buttons */
  margin-top: 0px;
  margin-bottom: 0px; /* Reduced from 25px */
  width: 95%; /* Updated percentage */
  max-width: 500px; /* Added max-width */
  margin-left: auto; /* Center container */
  margin-right: auto; /* Center container */
  box-sizing: border-box;
  align-items: stretch; /* Make buttons fill height if needed, although fixed height is set */
`;

// Base Button Style (to be extended or used directly if simple)
const BaseButton = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  /* width: ${props => props.fullWidth ? '100%' : '150px'}; */ /* REMOVED conditional width */
  /* max-width: ${props => props.fullWidth ? 'none' : '150px'}; */ /* REMOVED conditional max-width */
  height: 48px; /* Increased height */
  flex-shrink: 0;
  border: none;
  border-radius: 15px; /* Apply border-radius here */
  cursor: pointer;
  transition: background-color 0.3s ease, box-shadow 0.3s ease, opacity 0.3s ease;
  font-family: ${theme.fonts.main};
  font-size: 18px; /* Adjusted from 20px for better fit */
  font-style: normal;
  font-weight: 400; /* Adjusted from 500 */
  line-height: normal;
  text-decoration: none; /* For 'as="a"' usage */
  gap: 8px; /* Space between icon and text */
  padding: 0 15px; /* Default padding, override if needed */
  box-sizing: border-box; /* Ensure padding and border are included in the element's total width and height */

  &:disabled {
    opacity: 0.7;
    cursor: not-allowed;
  }
`;

// Renamed from InstagramButton
export const PrimaryActionButton = styled(BaseButton)`
  background: ${theme.colors.bleu_fonce};
  box-shadow: ${props => props.isActive ? 'none' : '0px 2px 0px 0px #1E99E0'}; /* Match secondary button shadow offset */
  color: ${theme.colors.white}; /* #FFF */
  flex-grow: 1; /* Take remaining space */
  min-width: 100px; /* Prevent shrinking too much */
  transform: ${props => props.isActive ? 'translateY(2px)' : 'translateY(0)'};
  transition: transform 0.15s ease-in-out, box-shadow 0.15s ease-in-out, background-color 0.2s ease;

  &:hover:not(:disabled) {
    /* background: ${theme.colors.bleu_tres_fonce}; */ /* REMOVED background change on hover */
    box-shadow: ${props => props.isActive ? 'none' : '0px 1px 0px 0px #1E99E0'}; /* Adjusted hover shadow offset */
  }

  /* Removed specific active state styles as isActive prop handles it */
`;

// Define ButtonIcon before SecondaryActionButton that uses it
export const ButtonIcon = styled.img`
  width: 24px; /* Increased size */
  height: 24px; /* Increased size */
`;

// Renamed from FollowButton
export const SecondaryActionButton = styled(BaseButton)`
  border: 1px solid #E6E6E6;
  background: ${theme.colors.white}; /* Keep background white */
  box-shadow: ${props => props.isActive ? 'none' : '0px 2px 0px 0px #E6E6E6'};
  color: ${theme.colors.noir}; /* Default text/icon color */
  width: 48px; /* Keep square shape */
  min-width: 48px;
  flex-shrink: 0;
  padding: 0; /* Remove padding to center icon */
  transform: ${props => props.isActive ? 'translateY(2px)' : 'translateY(0)'};
  transition: transform 0.15s ease-in-out, box-shadow 0.15s ease-in-out, background-color 0.2s ease;

  &:hover:not(:disabled) {
    /* No background change on hover */
    box-shadow: ${props => props.isActive ? 'none' : '0px 1px 0px 0px #E6E6E6'};
  }

  /* Removed specific active state styles as isActive prop handles it */

  & > ${ButtonIcon} {
     /* No specific icon styling needed here anymore */
  }
`;

export const InfoSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 15px; /* Space between info boxes */
  width: 95%; /* Updated percentage */
  max-width: 500px; /* Added max-width */
  margin: ${props => props.areBothActionButtonsVisible ? '20px' : '0px'} auto 20px auto; /* Conditional top margin */
`;

export const InfoBox = styled.div`
  display: flex;
  align-items: center;
  width: 100%; /* Fill InfoSection (90%) */
  /* width: 320px; */ /* Removed fixed width */
  min-height: 57px; /* Figma spec, now as min-height */
  flex-shrink: 0;
  border-radius: 15px;
  border: 2px solid #E6E6E6;
  background: rgba(255, 255, 255, 0.00); /* Transparent background */
  padding: 10px 15px; /* Added vertical padding, kept horizontal */
  box-sizing: border-box;
`;

export const InfoIcon = styled.img`
  width: 24px; /* Adjust size */
  height: 24px;
  margin-right: 15px; /* Space between icon and text */
  flex-shrink: 0;
`;

export const InfoTextContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  flex-grow: 1; /* Take remaining space */
`;

export const InfoTitle = styled.p`
  color: #4C4C4C;
  font-family: ${theme.fonts.main};
  font-size: 14px;
  font-style: normal;
  font-weight: 400; /* Figma: 400 */
  line-height: normal;
  margin: 0;
  /* white-space: nowrap; // Prevent wrapping if needed */
  /* overflow: hidden; // Hide overflow */
  /* text-overflow: ellipsis; // Add ellipsis */
`;

export const InfoSubtitle = styled.p`
  color: #B3B3B3; /* Adjusted color slightly from #E6E6E6 for visibility */
  font-family: ${theme.fonts.main};
  font-size: 12px; /* Adjusted from 14px for better hierarchy */
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  margin: 2px 0 0 0; /* Small top margin */
`;


export const LoadingErrorContainer = styled.div`
  padding: 40px 20px;
  text-align: center;
  color: #666;
  min-height: 200px; /* Ensure it takes some space */
  display: flex;
  justify-content: center;
  align-items: center;
`;

// Helper for Icon inside buttons if needed (example)
// export const ButtonIcon = styled.img`
//   width: 20px;
//   height: 20px;
//   margin-right: 8px; /* Space between icon and text */
// `;

// Create a wrapper for the horizontal domain icon/counter part
export const DomainDisplayWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  min-height: 20px; 
`;

// =============== STYLES MERGED FROM OLD Profile/styles.js ===============

// IoSettingsOutline is imported in UserProfilePage.js directly
// import quizBuzzIcon from '../../assets/quiz_buzz_icon.png'; // Asset, imported in JS file

/** Rubrique title (from Profile/styles.js) **/
export const RubriqueTitle = styled.h2`
  text-align: left;
  color: #000;
  font-family: 'Gabarito', sans-serif;
  font-size: 18px;
  font-weight: 400;
  margin: 15px auto -8px auto; /* Centered with top/bottom margins */
  width: 95%;
  max-width: 500px; /* Consistent with other containers */
`;

/* Recap Section (from Profile/styles.js) */
export const RecapContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 10px; /* Adjusted gap */
  width: 95%;
  max-width: 500px; /* Consistent with other sections */
  margin: 0 auto 0px auto; /* Reduced bottom margin from 20px */
`;

export const StatBox = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  gap: 0;
  padding: 5px 10px; /* Adjusted padding to reduce height */
  border-radius: 15px;
  background-color: ${props => props.bgColor || '#0066FF'};
  color: #FFF; /* Ensure text is white */
  /* filter: drop-shadow(2px 2px 2px rgba(0, 0, 0, 0.25)); */ /* Removed shadow */
  cursor: ${props => props.onClick ? 'pointer' : 'default'};
  position: relative; /* Added for absolute positioning of heart icon */
`;

export const HeartIcon = styled.img`
  position: absolute;
  right: 30px; /* Changed from 10px to 30px to move it more to the left */
  top: 50%;
  transform: translateY(-50%);
  width: 20px;
  height: 20px;
`;

export const StatNumber = styled.div`
  color: #FFF;
  font-family: 'Gabarito', sans-serif;
  font-size: 30px; /* Adjusted size */
  font-weight: 400; /* Adjusted weight */
  line-height: normal;
  margin-left: 10%;
  margin-bottom: -5px; /* Adjust to pull label closer */
`;

/* Mes swipes Section (from Profile/styles.js) */
export const SwipeSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 10px; /* Reduced from 20px */
  width: 95%;
  max-width: 500px;
  margin-left: auto;
  margin-right: auto;
`;

export const SwipeBox = styled.div`
  width: 100%;
  min-height: 70px; /* Adjusted height */
  border-radius: 15px;
  background: #FFF; /* Reverted to white background */
  border: 1px solid ${({ theme }) => theme.colors.gris_clair_default}; /* Border uses gris_clair_default */
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 0 15px; /* Adjusted padding */
  cursor: pointer;
  box-sizing: border-box;
  box-shadow: ${({ theme, isActive }) => isActive ? 'none' : `0px 2px 0px 0px ${theme.colors.gris_clair_default}`}; /* Shadow uses gris_clair_default */
  transform: ${({ isActive }) => isActive ? 'translateY(2px)' : 'translateY(0)'}; 
  transition: all 0.15s ease; 
`;

export const QuizIcon = styled.div`
  width: 35px; /* Adjusted size */
  height: 35px;
  background: url(${props => props.src}) center / contain no-repeat;
  flex-shrink: 0;
`;

export const SwipeText = styled.div`
  color: #535252;
  font-family: 'Gabarito', sans-serif;
  font-size: 18px; /* Adjusted size */
  font-weight: 400;
`;

/* Generic BoxContainer for Domains, Specialties, Infos (from Profile/styles.js) */
export const BoxContainer = styled.div`
  width: 95%;
  max-width: 500px;
  border-radius: 15px;
  background: #FFF;
  border: 1px solid ${({ theme }) => theme.colors.gris_clair_default};
  padding: 15px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin: 0 auto 10px auto; /* Reduced bottom margin from 20px */
  box-sizing: border-box;
`;

export const ItemBox = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  min-height: 50px; /* Adjusted height */
  cursor: ${props => props.onClick ? 'pointer' : 'default'};
`;

export const ItemIcon = styled.div`
  width: 35px; /* Adjusted size */
  height: 35px;
  flex-shrink: 0;
  background: ${({ bgImage }) => bgImage ? `transparent url(${bgImage}) center / contain no-repeat` : 'transparent'};
`;

export const ItemText = styled.div`
  flex: 1;
  color: #535252;
  font-family: 'Gabarito', sans-serif;
  font-size: 16px; /* Adjusted size */
  font-weight: 400;
  line-height: normal;
`;

export const ItemSeparator = styled.div`
  width: 100%; /* Fill container */
  height: 1px;
  background: ${({ theme }) => theme.colors.background_fonce}; /* Lighter separator */
`;

export const VoirPlusButton = styled.div`
  color: rgba(131, 128, 128, 0.90); /* Darker for better visibility */
  font-family: 'Geologica', sans-serif;
  font-size: 14px;
  font-style: italic;
  font-weight: 400;
  cursor: pointer;
  text-align: right; /* Align to right */
  padding-top: 5px;
`;

/* ScoreBox for specialties (from Profile/styles.js) */
export const ScoreBox = styled.div`
  border-radius: 5px;
  background: #000;
  min-width: 50px; /* Adjusted size */
  height: 35px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 5px;
`;

export const ScoreText = styled.div`
  color: #FFF;
  font-family: 'Gabarito', sans-serif;
  font-size: 16px; /* Adjusted size */
  font-weight: 400;
`;

/* Pseudo Edit (from Profile/styles.js) */
export const PseudoTextArea = styled.textarea`
  flex: 1;
  min-height: 35px;
  height: auto; /* Allow wrapping */
  padding: 8px;
  border: 1px solid #ddd;
  border-radius: 8px;
  font-size: 16px;
  font-family: 'Gabarito', sans-serif;
  resize: none;
  background-color: #fdfdfd;
  box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.06);
  &:focus {
    outline: none;
    border-color: ${({ theme }) => theme.colors.black};
    box-shadow: inset 0 1px 3px rgba(0, 0, 0, 0.1);
  }
`;

export const ConfirmButton = styled.button`
  padding: 8px 12px;
  border-radius: 8px;
  background-color: #000;
  color: #fff;
  border: none;
  cursor: pointer;
  font-family: 'Gabarito', sans-serif;
  font-size: 14px;
  font-weight: 400;
  box-shadow: 0 0 2px rgba(0, 0, 0, 0.15);
  transition: background-color 0.2s ease;
  &:hover {
    background-color: #222;
  }
`;

/* Grade Slider (from Profile/styles.js) */
export const SliderContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  margin: 10px 0;
  padding: 10px;
  border-radius: 8px;
  background: #f9f9f9;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
`;

export const SliderValue = styled.div`
  font-family: 'Gabarito', sans-serif;
  font-size: 16px;
  font-weight: 400;
  color: #000;
  min-width: 25px; /* Ensure space for '20' */
  text-align: right;
`;

export const GradeSlider = styled.input.attrs({ type: 'range' })`
  width: 100%;
  -webkit-appearance: none;
  height: 6px;
  background: #ccc; /* Lighter track */
  border-radius: 3px;
  outline: none;
  margin: 0 8px;
  &::-webkit-slider-thumb {
    -webkit-appearance: none;
    width: 20px;
    height: 20px;
    background: ${theme.colors.primary}; /* Theme color for thumb */
    border-radius: 50%;
    cursor: pointer;
    box-shadow: 0 0 2px rgba(0, 0, 0, 0.3);
    border: 1px solid ${theme.colors.primary_dark};
  }
  &::-moz-range-thumb {
    width: 18px;
    height: 18px;
    background: ${theme.colors.primary};
    border-radius: 50%;
    cursor: pointer;
    border: 1px solid ${theme.colors.primary_dark};
  }
`;

export const ConfirmGradeButton = styled(ConfirmButton)` // Extends ConfirmButton
  font-size: 14px;
  padding: 6px 10px;
`;

export const ErrorText = styled.p`
  color: ${({ theme }) => theme.colors.rouge};
  font-size: ${({ theme }) => theme.fontSizes.small};
  text-align: center;
  margin-top: 5px;
`; 